import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Flex, Type, Divider, Anchor } from "@ebscois/react-component-library";
import {
  AlgorithmIcon,
  AlgorithmPDFText,
  AlgorithmTitleText,
} from "./_.styled";
import { ALGORITHM_LOGO_PDF_URL } from "../../constants/ui";
import { affordances, logAlgorithmViewed } from "../../util/analytics";

const buildViewInContextUrl = (associatedTopics, slugPubType, slugTitle) => {
  const match = associatedTopics?.find((topic) => {
    const splitSlug = topic.slug.split("/");
    return splitSlug[1] === slugPubType && splitSlug[2] === slugTitle;
  });
  return match ? `${match.slug}#${match.an.toUpperCase()}` : ``;
};

const AlgorithmsTab = ({
  handleCTA,
  handleOpenPDF,
  isNonFreePreview,
  mediaItems,
  slugPubType,
  slugTitle,
}) => (
  <Flex container column>
    {mediaItems.map((algorithm, index) => (
      <React.Fragment key={algorithm.publicId}>
        <Flex cell span={12}>
          <AlgorithmIcon src={ALGORITHM_LOGO_PDF_URL} alt={algorithm.title} />
          <Flex
            container
            column
            justify={{ content: !algorithm?.associatedTopics && "center" }}
          >
            <Type fontSize="sm">
              Algorithm {index + 1}:{" "}
              {algorithm?.hasPdf && (
                <Anchor
                  kind="anchor"
                  fontSize="sm"
                  onClick={() => {
                    if (isNonFreePreview) {
                      handleCTA();
                    } else {
                      handleOpenPDF(algorithm.pdfUrl);
                      logAlgorithmViewed({
                        title: algorithm.title,
                        mediaId: algorithm.publicId,
                        type: algorithm.format,
                        affordance: affordances.TOPIC_GALLERY,
                      });
                    }
                  }}
                >
                  <AlgorithmTitleText>{algorithm.title}</AlgorithmTitleText>
                  <AlgorithmPDFText>{"[PDF]"}</AlgorithmPDFText>
                </Anchor>
              )}
            </Type>
            {algorithm?.associatedTopics && (
              <Anchor
                fontSize="sm"
                marginTop="xs"
                linkComponent={Link}
                href={buildViewInContextUrl(
                  algorithm.associatedTopics,
                  slugPubType,
                  slugTitle
                )}
              >
                View in topic
              </Anchor>
            )}
          </Flex>
        </Flex>
        <Divider />
      </React.Fragment>
    ))}
  </Flex>
);

AlgorithmsTab.propTypes = {
  handleOpenPDF: PropTypes.func.isRequired,
  mediaItems: PropTypes.arrayOf(
    PropTypes.shape({
      publicId: PropTypes.string.isRequired,
      hasPdf: PropTypes.bool.isRequired,
      pdfUrl: PropTypes.string,
      title: PropTypes.string.isRequired,
      associatedTopics: PropTypes.arrayOf(
        PropTypes.shape({
          slug: PropTypes.string.isRequired,
          an: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default AlgorithmsTab;
